import printIcon from "@public/icon/ico-print.svg";
import Image from "next/image";

const Print = () => {
  return (
    <button
      onClick={() => window.print()}
      className="flex items-center gap-2.5 hover:cursor-pointer hover:underline print:hidden"
    >
      <Image width={32} height={32} src={printIcon} alt="Stampa" />
      <span className="hidden text-base sm:block">Stampa</span>
    </button>
  );
};

export default Print;
